import { render } from "./Mails.vue?vue&type=template&id=0fd2526c&scoped=true"
import script from "./Mails.vue?vue&type=script&lang=js"
export * from "./Mails.vue?vue&type=script&lang=js"

import "./Mails.vue?vue&type=style&index=0&id=0fd2526c&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd2526c"]])

export default __exports__